import React from 'react'
import { LeftOutline } from 'antd-mobile-icons'
import './styles/ChatHeader.css'
import { Button } from 'antd-mobile'
import { FaRegCommentDots, FaUsers } from 'react-icons/fa'
import { SlPin } from 'react-icons/sl'

const ChatHeader = ({
  title,
  onBack,
  onViewThreads,
  threadUnreadCount,
  onShowPinnedMessages,
  search,
  onShowMembers
}) => {
  return (
    <div className="chat-header">
      <div className="chat-left">
        {onBack && (
          <Button className="icon-button" onClick={onBack} aria-label="Go back">
            <LeftOutline />
          </Button>
        )}
        <h2 className="chat-title">
          {title.charAt(0).toUpperCase() + title.slice(1)}
        </h2>
      </div>

      <div className="chat-actions">
        {onShowMembers && (
          <Button
            className="icon-button"
            onClick={onShowMembers}
            aria-label="Show Members"
          >
            <FaUsers size={20} />
          </Button>
        )}
        {onViewThreads && (
          <div className="action-icon-wrapper">
            <Button
              className="icon-button"
              onClick={onViewThreads}
              aria-label="View Threads"
            >
              <FaRegCommentDots />
            </Button>
            {threadUnreadCount > 0 && (
              <span className="badge-icon">{threadUnreadCount}</span>
            )}
          </div>
        )}
        {onShowPinnedMessages && (
          <Button
            className="icon-button"
            onClick={onShowPinnedMessages}
            aria-label="Show Pinned Messages"
          >
            <SlPin />
          </Button>
        )}
        {search && (
          <Button
            className="icon-button"
            onClick={typeof search === 'function' ? search : undefined}
            aria-label="Search"
          >
            <svg width="22" height="22" viewBox="0 0 22 22">
              <circle cx="10" cy="10" r="8" stroke="#323F4A" strokeWidth="2" fill="none" />
              <line x1="16" y1="16" x2="21" y2="21" stroke="#323F4A" strokeWidth="2" />
            </svg>
          </Button>
        )}
      </div>
    </div>
  )
}

export default ChatHeader
